export const bidConstants = {
  CHANGE_BID_FIELD: 'CHANGE_BID_FIELD',
  RESET_BID_STORE: 'RESET_BID_STORE',
  VALIDATE_BID_STORE: 'VALIDATE_BID_STORE',
  RESET_IMPRESSIONS_FIELD: 'RESET_IMPRESSIONS_FIELD',
};
